function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { sortableContainer } from 'react-sortable-hoc';
import ArrayFieldSortableItem from "./ArrayFieldSortableItem";
const ArrayFieldSortableList = sortableContainer(props => {
  const arrayProps = props.arrayProps,
        items = props.items;
  const registry = arrayProps.registry,
        canAdd = arrayProps.canAdd,
        onAddItem = arrayProps.onAddItem,
        onChange = arrayProps.onChange;
  const SchemaLayout = registry.fields.SchemaLayout;
  return React.createElement(SchemaLayout, _extends({}, arrayProps, {
    onAdd: canAdd && onAddItem,
    onChange: onChange
  }), items.map((value, index) => {
    const itemProps = _extends({}, arrayProps, {
      itemIndex: index
    });

    return React.createElement(ArrayFieldSortableItem, _extends({}, itemProps, {
      value: value,
      index: index,
      key: "item-" + index
    }));
  }));
});
export default ArrayFieldSortableList;